import type { ProfessionPageConfig } from '../professions/types'
import { siteCanonicalUrl } from '../siteDestinations'

/**
 * Ficha JSON-LD (WebPage + FAQPage) de uma página por profissão, gerada do
 * mesmo conteúdo que a página renderiza. Sem preço e sem endereço.
 */
export function professionStructuredData(config: ProfessionPageConfig) {
  const pageUrl = `${siteCanonicalUrl}${config.path}`
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: config.title,
        description: config.description,
        inLanguage: 'pt-BR',
        isPartOf: { '@id': `${siteCanonicalUrl}/#website` },
        about: { '@id': `${siteCanonicalUrl}/#organization` },
        primaryImageOfPage: `${siteCanonicalUrl}/assets/share/oficina-ia-1200x630.png`,
      },
      {
        '@type': 'FAQPage',
        '@id': `${pageUrl}#faq`,
        mainEntity: config.faq.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
  } as const
}

export function professionStructuredDataScript(config: ProfessionPageConfig): string {
  const json = JSON.stringify(professionStructuredData(config)).replace(/</g, '\\u003c')
  return `<script type="application/ld+json">${json}</script>`
}
